import axios from 'axios'
import { useEffect, useState } from 'react'

export function useMaintenanceMessageApi() {
  const [isLoading, setIsLoading] = useState(false)
  const [data, setData] = useState(null)
  const [error, setError] = useState(null)
  useEffect(() => {
    async function fetchMessage() {
      setIsLoading(true)
      try {
        const resp = await axios.get('/api/rest/maintenance/message')
        setData(resp.data)
      } catch (err) {
        setError(err.data)
      } finally {
        setIsLoading(false)
      }
    }
    fetchMessage()
  }, [])
  return [isLoading, data, error]
}
